import React from "react";

const DmwfSection2 = () => {
  return (
    <div className="column-sections pb-20">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="column-content pb-40">
            <div class="service_style_two_title pb-3 text-left">
                  <h4>How ProPlus Data Helps</h4>
            </div>
              <p className="text-left black"><a href="https://proplusdata.co/">ProPlus Data</a> enables GTM teams to move earlier and move smarter by combining:

              </p>
              <div class="col-md-12 col-lg-6 text-left">
            <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>Verified renewal timelines</h6>
              </div>
            </div>
            <div class="why-choose-icon " data-wow-delay=".6">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check2"></i></span>
                <h6>Installed technology insights</h6>
              </div>
            </div>
            <div class="why-choose-icon" data-wow-delay=".7">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check2"></i></span>
                <h6>Account-level intelligence</h6>
              </div>
            </div>
             <div class="why-choose-icon" data-wow-delay=".7">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check2"></i></span>
                <h6>Decision-maker mapping</h6>
              </div>
            </div>
            <p>All designed to support pipeline creation, expansion, and competitive displacement.</p>
            {/* <div class="service_style_two_title pt-4 text-left">
                  <h6 className="w-100">One solution that sparked major interest: Next Tech Purchase®, our proprietary predictive engine that forecasts upcoming technology investments before traditional intent data can. For marketing teams, it means one thing:
                  </h6>
            </div>   */}
          
          </div>
            {/* <p className="text-left">One solution that sparked major interest: <a href="https://proplusdata.co/next-tech-purchase">Next Tech Purchase®</a> , our proprietary predictive engine that forecasts upcoming technology investments before traditional intent data can. For marketing teams, it means one thing:</p>
            <p className="text-left">A first-mover advantage on tech-buying accounts that are still off your radar.</p> */}
          <div class="service_style_two_title pt-4 text-left">
                  <h4>Missed Us at DMWF?</h4>
            </div>
          <p className="text-left">If you didn’t get a chance to connect with us at DMWF Europe or want to continue the conversation, we’d be happy to show you how Renewal Intelligence fits into your GTM strategy.
</p>
<div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>Explore Renewal Intelligence</h6>
              </div>
            </div>
            <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>Book a conversation with our team</h6>
              </div>
            </div>
         
          

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DmwfSection2;
